import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TransactionStatus } from '@rd/types/transaction-status.type';
import { CashbackState } from '../reducers/cashback.reducer';

export const getCashbackState =
  createFeatureSelector<CashbackState>('cashback');

export const getCashbackFormState = createSelector(
  getCashbackState,
  (state: CashbackState) => state.formData,
);

export const getCashbackError = createSelector(
  getCashbackState,
  (state: CashbackState) => state.cashback.error,
);

export const getCashbackLoading = createSelector(
  getCashbackState,
  (state: CashbackState) => state.cashback.status === TransactionStatus.LOADING,
);

export const getCashbackSuccess = createSelector(
  getCashbackState,
  (state: CashbackState) => state.cashback.status === TransactionStatus.SUCCESS,
);

export const getCashbackFail = createSelector(
  getCashbackState,
  (state: CashbackState) => state.cashback.status === TransactionStatus.FAIL,
);
